import React, { useState, useContext, useEffect } from 'react';
import Card, { CardBody } from '../../components/bootstrap/Card';
import Page from '../../layout/Page/Page';
import PageWrapper from '../../layout/PageWrapper/PageWrapper';
import logo from '../../assets/images/brand_dark.png';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Button from '../../components/bootstrap/Button';
import classNames from 'classnames';
import useDarkMode from '../../hooks/useDarkMode';
import LANG, { getLangWithKey } from '../../lang';
import { useTranslation } from 'react-i18next';
import Icon from '../../components/icon/Icon';
import FormGroup from '../../components/bootstrap/forms/FormGroup';
import Input from '../../components/bootstrap/forms/Input';
import { useFormik } from 'formik';
import InputGroup from '../../components/bootstrap/forms/InputGroup';
import showNotification from '../../components/extras/showNotification';
import UserService from '../../services/UserService';
import { useMst } from '../../models';
import ThemeContext from '../../contexts/themeContext';
import moment from 'moment';
import bgImage from "../../assets/video/home.mp4";
import bgImage1 from "../../assets/images/home_bg.png";
import icruTestImage from "../../assets/images/icrutest.png";
import graphImage from "../../assets/images/graph2.png";
import icruImage from "../../assets/images/icru_img.png";
import bgImage3 from "../../assets/images/home_bg3.png";
import NoticeBoard from '../dashboard/component/NoticeBoard';
import { useEffectOnce } from 'react-use';
import CountUp, { useCountUp } from "react-countup";
import TextLoop from "react-text-loop";

const Icru = (props) => {
    const navigate = useNavigate();
    const { darkModeStatus } = useDarkMode();
    const { t, i18n } = useTranslation(['translation', 'menu']);
    const { user } = useMst();
    const { setNoticeCount, lang, setLang } = useContext(ThemeContext);
    const [visiblePW, setVisiblePW] = useState(false);
    // const { updateUser } = useChannelIOApi(); // 새로운 버전에서 x

    const [windowSize, setWindowSize] = useState({
        width: undefined,
        height: undefined,
    });

    useEffectOnce(() => {
        const handleResize = () => {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };

        window.addEventListener('resize', handleResize);
        handleResize();

        return () => window.removeEventListener('resize', handleResize);
    });

    const loginData = useFormik({
        initialValues: {
            email: '',
            password: '',
        },
        onSubmit: (values) => {
            if (!values.email || !values.password) {
                showNotification(t('로그인'), t('필수 정보를 확인해주세요.'), 'danger');
            } else {
                requestLogin(values);
            }
        },
    });

    const changeLanguage = (lng) => {
        i18n
            .changeLanguage(lng)
            .then(() => {
                moment.locale(lng);
                showNotification(
                    <span className='d-flex align-items-center'>
                        <Icon icon={getLangWithKey(lng)?.icon} size='lg' className='me-1' />
                        <span>{`${getLangWithKey(lng)?.text}`}</span>
                    </span>,
                    t('You updated the language of the site.')
                );
            })
            .then(() => {
                setLang(lng);
            });
    };

    // 로그인 시 읽지 않은 게시물 카운트
    const readNoticeCount = async () => {
        const noticeCount = await BoardService.readCount('notice', user.me.currentCompanyId);
        setNoticeCount(noticeCount?.data || 0);
    };

    const requestLogin = async (values) => {
        const loginData = await UserService.login(values);
        if (loginData?.message) {
            // 로그인 실패 시
            showNotification(t('로그인'), t(loginData?.message), 'danger');
        } else {
            user
                .authMe()
                .then(async () => {
                    navigate('/dashboard')
                })
                .catch((e) => {
                    console.log(e);
                    showNotification(t('로그인'), t('로그인에 실패하였습니다.') + t('다시 확인해주세요') + '.', 'danger');
                });
        }
    };

    return (
        <>
            <PageWrapper title={'Home'}>
                <div className='icru-bg'></div>

                <Page container='fluid'>
                    <div className='row align-items-center justify-content-center'
                        style={{
                            height: 600,
                            marginTop: -100
                        }}
                    >
                        <div className='col-xl-12 col-sm-12 white text-center'>
                            <h1 className='font font-40 white'>기질진단 소개</h1>
                            <h2 className='mt-30 '>I Can R.E.A.D yoU!</h2>
                        </div>
                    </div>
                    <div className='col-xl-12 col-xxl-12'>
                        <Card style={{ 
                            backgroundColor: '#010101',
                            height: 450
                        }}>
                            <CardBody className='text-center pt-100'>
                                <div className='font font-28'>ICRU기질진단도구<span className='white'>란?</span></div>
                                <div className='font font-22 white' style={{ marginTop: 30, marginBottom: 30}}>
                                    <div 
                                        className='font-16 text-start auto'
                                        style={{
                                            maxWidth: 565,
                                            height: 50,
                                            padding: 15,
                                            backgroundColor: '#181717'
                                        }}>
                                        <Icon icon={'check-circle'} className="font font-22" />
                                        <span style={{marginLeft: 10}}>ICRU : I Can R.E.A.D yoU 의 약자</span>
                                    </div>
                                    <div 
                                        className='font-16 text-start auto'
                                        style={{
                                            marginTop: 20,
                                            maxWidth: 565,
                                            height: 50,
                                            padding: 15,
                                            backgroundColor: '#181717'
                                        }}>
                                        <Icon icon={'check-circle'} className="font font-22" />
                                        <span style={{ marginLeft: 10 }}>기질과 역량을 진단하는 기질유형 진단도구</span>
                                    </div>
                                    <div 
                                        className='font-16 text-start auto'
                                        style={{
                                            marginTop: 20,
                                            maxWidth: 565,
                                            height: 50,
                                            padding: 15,
                                            backgroundColor: '#181717'
                                        }}>
                                        <Icon icon={'check-circle'} className="font font-22" />
                                        <span style={{ marginLeft: 10 }}>현존하는 79개의 심리유형 진단도구를 최초로 통합한 진단도구</span>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                        <Card style={{
                            backgroundColor: 'transparent',
                            marginTop: -20,
                            overflow: 'hidden',
                        }}>
                            <CardBody className='text-center'>
                                <div className='row g-3 text-center topmenu-container'>
                                    <div className='col-auto font font-28'>
                                        <div className='mt-30'>
                                            본성은 본질로 부터
                                        </div>
                                    </div>
                                </div>
                                <div className='font-16 dark2 auto' 
                                    style={{ 
                                        marginTop: 50,
                                        marginBottom: -300,
                                        backgroundColor: '#00FF94',
                                        maxWidth: 500,
                                        height: 500,
                                        borderRadius: 500,
                                    }}>
                                    <div className='auto' style={{width: 300, paddingTop: 100}}>
                                        칼 구스타프 융의 4가지 인지기능을 기반으로, 현존하는 79개의 심리유형 진단도구를 최초로 통합한 기질 유형 진단도구 입니다
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                        <Card style={{
                            backgroundColor: '#010101',
                            marginTop: -20,
                        }}>
                            <CardBody
                                className='text-center'
                                style={{
                                    padding: 50
                                }}>
                                <div className='font font-28' style={{ marginTop: 20, marginBottom: 10 }}>
                                    자기다움을 누릴 권리
                                </div>
                                <div className='font font-14 white col-9 col-xl-4 col-sm-4 auto'>
                                    타고난 기질 프로파일링을 통해 여러분의 자기다움 읽어드립니다.
                                </div>
                                <div className='row col-xl-6 col-lg-12 col-md-12 justify-content-center auto text-start'>
                                    <div className='col-12 col-md-4'>
                                        <div className='col-auto text-start font font-40' style={{marginLeft: 20}}>
                                            01
                                        </div>
                                        <div className='col-auto gray-box2' style={{ marginTop: -30 }}>
                                            <div className='font font-14 white'>
                                                기질 프로파일링을 기반으로
                                            </div>
                                            <div className='font font-20 pt-30'>
                                                자기성장 솔루션을 제시합니다.
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-12 col-md-4'>
                                        <div className='col-auto font font-40' style={{ marginLeft: 20 }}>
                                            02
                                        </div>
                                        <div className='col-auto gray-box2' style={{ marginTop: -30 }}>
                                            <div className='font font-14 white'>
                                                기질 프로파일링을 기반으로
                                            </div>
                                            <div className='font font-20 pt-30'>
                                                회복탄력성 정도와 원인을 읽어드립니다.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                        <Card style={{
                            backgroundColor: 'transparent',
                        }}>
                            <CardBody
                                className='text-center'
                                style={{
                                    padding: 50
                                }}>
                                <div className='font font-28 white' style={{ marginTop: 20, marginBottom: 10 }}>
                                    연간 추적진단
                                </div>
                                <div className='font font-14 white text-center'>
                                    <div className='auto' style={{ width: 240, padding:5, marginTop: 20, marginBottom: 20, backgroundColor: '#343434', borderRadius: 100 }}>
                                        <Icon icon={'calendar3'} className="font font-16" />
                                        <span style={{ marginLeft: 10 }}>연간 추적 진단 : 월 1회 총 12번</span>
                                    </div>
                                </div>
                                <div className='font font-14 white col-xl-2 col-sm-2 auto'>
                                    월 1회, 총12번의 진단결과를 추적하여 보다 더 정확하게 자기다움을 읽어드립니다.
                                </div>
                                <img src={graphImage} alt="그래프" />
                            </CardBody>
                        </Card>
                        <Card style={{
                            backgroundColor: '#212024',
                        }}>
                            <CardBody
                                className='text-center'
                                style={{
                                    padding: 50,
                                }}>
                                <div className='font font-28 white col-xl-4 col-lg-6 col-md-12 auto' style={{ marginTop: 20, marginBottom: 20 }}>
                                    다양한 방송프로그램에서 활용된 ICRU진단도구
                                </div>
                                <div className='row col-xl-4 col-lg-6 col-md-12 justify-content-center auto text-start'>
                                    <div className='col-auto icru-box'>
                                        <span>KBS 스페셜 | 김정은의 두얼굴</span>
                                    </div>
                                    <div className='col-auto icru-box'>
                                        <span>SBS 뉴스토리 | 남북미 정상 분석</span>
                                    </div>
                                    <div className='col-auto icru-box'>
                                        <span>tvN 식스센스2 | 출연진 분석</span>
                                    </div>
                                    <div className='col-auto icru-box'>
                                        <span>채널A 이제만나러갑니다 | 북한 주요인물 분석</span>
                                    </div>
                                    <div className='col-auto icru-box'>
                                        <span>JTBC4 인간이왜그래 | 출연진 분석</span>
                                    </div>
                                </div>

                                <div className='auto' style={{marginTop: 30}}>
                                    <img src={icruImage} alt="그래프" />
                                </div>

                                <div style={{
                                    height: 300, backgroundColor: '#fff', zIndex: -2, marginTop: -243,
                                    marginLeft: -50, marginRight: -50, width: '120%'
                                }}>

                                </div>
                            </CardBody>
                        </Card>
                        <Card style={{
                            backgroundColor: '#fff',
                            marginTop: -70,
                            marginBottom: -10
                        }}>
                            <CardBody
                                className='text-center'
                                style={{
                                    padding: 50
                                }}>
                                <div className='font font-28 dark col-xl-4 col-lg-6 col-md-12 auto' style={{ marginTop: 20, marginBottom: 20 }}>
                                    ICRU기질진단은 이런것들을 알려줘요
                                </div>
                                <div className='row col-12 col-xl-6 col-lg-6 col-md-6 col-sm-6 justify-content-center auto text-start'>
                                    <div className='col-auto dark'>
                                        <div className='icru-box2'>나는 4가지 라인 중 어떤 라인에 속할까?</div>
                                        <div className='icru-box2'>나의 히어로 유형은 어떤 유형?</div>
                                        <div className='icru-box2'>결과 그래프로 더 자세히 들여다보기</div>
                                        <div className='icru-box2'>나를 움직이는 근본 에너지는?</div>
                                        <div className='icru-box2'>나의 강점은 무엇일까?</div>
                                        <div className='icru-box2'>나의 강점을 강화해줄 미션은?</div>
                                        <div className='icru-box2'>나의 커뮤니케이션 스타일은?</div>
                                        <div className='icru-box2'>나의 까똑 및 SNS 스타일은?</div>
                                        <div className='icru-box2'>나의 커뮤니케이션 능력 키우는 특급 비법</div>
                                    </div>
                                    <div className='col-auto dark'>
                                        <div className='icru-box2'>남들이 보는 나의 이미지는?</div>
                                        <div className='icru-box2'>내가 좋아하는 패션 스타일은?</div>
                                        <div className='icru-box2'>성공적인 비즈니스 미팅을 위한 이미지 연출법은?</div>
                                        <div className='icru-box2'>나의 직업 가치관은?</div>
                                        <div className='icru-box2'>나의 생산성을 높여줄 업무환경은?</div>
                                        <div className='icru-box2'>나의 취약한 업무와 스트레스 증상은?</div>
                                        <div className='icru-box2'>나의 업무 생산성을 높여줄 행동강령과 업무아이템은?</div>
                                        <div className='icru-box2'>현재 나의 회복탄력성 지수와 번아웃 원인은?</div>
                                    </div>
                                </div>
                                <div className='font font-28 dark col-12 auto' style={{ marginTop: 50, marginBottom: 20 }}>
                                    ICRU기질진단 활용법
                                </div>
                                <div className='row col-12 justify-content-center auto text-center'>
                                    <div className='col-auto dark'>
                                        <div className='icru-box3'>나는 4가지 라인 중 어떤 라인에 속할까?</div>
                                        <div className='icru-box3'>나의 히어로 유형은 어떤 유형?</div>
                                        <div className='icru-box3'>결과 그래프로 더 자세히 들여다보기</div>
                                        <div className='icru-box3'>나를 움직이는 근본 에너지는?</div>
                                        <div className='icru-box3'>나의 강점은 무엇일까?</div>
                                        <div className='icru-box3'>나의 강점을 강화해줄 미션은?</div>
                                        <div className='icru-box3'>나의 커뮤니케이션 스타일은?</div>
                                        <div className='icru-box3'>나의 까똑 및 SNS 스타일은?</div>
                                        <div className='icru-box3'>나의 커뮤니케이션 능력 키우는 특급 비법</div>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                    </div>
                </Page>
            </PageWrapper>
        </>
    );
};
export default Icru;
